export function slugify(s) {
    return String(s || "")
      .toLowerCase()
      .trim()
      .replace(/['’]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }
  
  export function splitList(s) {
    return String(s || "")
      .split(",")
      .map((x) => x.trim())
      .filter(Boolean);
  }
  export function joinList(arr) {
    return (arr || []).join(", ");
  }
  
  export function splitMultiline(s) {
    return String(s || "")
      .split("\n")
      .map((x) => x.trim())
      .filter(Boolean);
  }
  export function joinMultiline(arr) {
    return (arr || []).join("\n");
  }
  
  export function isValidISODate(value) {
    // allow empty; when present must be YYYY-MM-DD and real
    if (!value) return true;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const [y, m, d] = value.split("-").map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    return (
      dt.getUTCFullYear() === y &&
      dt.getUTCMonth() === m - 1 &&
      dt.getUTCDate() === d
    );
  }
  